/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const usedSupplies = sqliteTable('used_supplies', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  encounter_id: text('encounter_id'),
  inventory_item_id: text('inventory_item_id'),
  inventory_batch_id: text('inventory_batch_id'),
  stock_movement_id: text('stock_movement_id'),
  invoice_id: text('invoice_id'),
  invoice_item_id: text('invoice_item_id'),
  item_name_snapshot: text('item_name_snapshot'),
  item_code_snapshot: text('item_code_snapshot'),
  supply_usage_type_snapshot: text('supply_usage_type_snapshot'),
  is_sellable_snapshot: integer('is_sellable_snapshot'),
  quantity: real('quantity'),
  unit_snapshot: text('unit_snapshot'),
  batch_no_snapshot: text('batch_no_snapshot'),
  expiry_date_snapshot: text('expiry_date_snapshot'),
  unit_price_snapshot: real('unit_price_snapshot'),
  cost_snapshot: real('cost_snapshot'),
  usage_status: text('usage_status'),
  billing_status: text('billing_status'),
  used_at: text('used_at'),
  used_by: text('used_by'),
  notes: text('notes'),
  reversed_at: text('reversed_at'),
  reversed_by: text('reversed_by'),
  reverse_reason: text('reverse_reason'),
  client_reference: text('client_reference'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
